import { ECustomerSource } from 'core/model/enums/customer.enum';
import { ICreditLimit } from 'core/model/interfaces/credits.interface';

export const canPurchaseFromSource = (source: ECustomerSource, creditLimits: Record<number, ICreditLimit>) =>
  creditLimits[source]?.canPurchase ?? true;

export const hasDebtBySource = (source: ECustomerSource, creditLimits: Record<number, ICreditLimit>) =>
  !canPurchaseFromSource(source, creditLimits);
